import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { accessService } from '../../../services/central-api/access';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    zIndex: number;
    disabled: boolean;
    labelFontSize?: number;
    required: boolean;
    companyId?: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function InternetCompanyDropdown({ value, setValue, zIndex, disabled, labelFontSize, required, companyId, form, fieldName }: Props) {
    const [selectableItems, setSelectableItems] = useState<{ label: string; value: number; }[]>([]);
    const [originalValues, setOriginalValues] = useState<SimplifiedInternetCompany[]>([]);

    useEffect(() => {
        if (!selectableItems.find(item => item.value === value)) {
            const item = originalValues.find(item => item.id === value);
            if (item) {
                setSelectableItems([
                    ...selectableItems,
                    { label: item.name, value: item.id }
                ]);
            }
        }
    }, [value]);

    async function getItems() {
        try {
            const items = await accessService.getInternetCompaniesSimplified(companyId);
            setOriginalValues(items);
            setSelectableItems(items.filter(item => !item.deletedAt).map((item: DropdownResource) => {
                return { label: item.name, value: item.id };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getItems();
    }, [companyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('internetCompany')}
            items={selectableItems}
            multiple={false}
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return <FilterDropdown
            label={translate('internetCompany')}
            items={selectableItems}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled}
            labelFontSize={labelFontSize}
            required={required}
        />;
    }
}

export default InternetCompanyDropdown;
